export const TEST_MAGNUM_GO_RESULT = {
  decisionStatus: 'ACCEPT',
  underwriting: [],
  externalExistingContract: false,
};
